var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('bread-crumb',{attrs:{"breadCrumbIteams":_vm.breadCrumbIteams}})],1),_c('AiSettingsPanel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }